const PILLS_TOOLKIT_FETCH = 'bfb/pills-tools/PILLS_TOOLKIT_FETCH';
const PILLS_TOOLKIT_FETCH_SUCCEEDED = 'bfb/pills-tools/PILLS_TOOLKIT_FETCH_SUCCEEDED';
const PILLS_TOOLKIT_FETCH_FAILED = 'bfb/pills-tools/PILLS_TOOLKIT_FETCH_FAILED';

export default {
  PILLS_TOOLKIT_FETCH,
  PILLS_TOOLKIT_FETCH_SUCCEEDED,
  PILLS_TOOLKIT_FETCH_FAILED,
};
